import { publicDataList, correction } from '@/api/goodStand'
import { msg } from '@/utils/index'

import Vue from 'vue'
import delAndEdit from './actions/delAndEdit'
import revent from './actions/revent'
import jiucuo from './actions/jiucuo'
Vue.component('delAndEdit', delAndEdit)
Vue.component('revent', revent)
Vue.component('jiucuo', jiucuo)
export default {
  data() {
    return {
      pageTitle: '',
      tabs: [],
      actions: [],
      loading: false,
      tableCol: [],
      tableData: [],
      pageSize: 30,
      pageIndex: 1,
      total: 0,
      templateParams: '' // 用来放置搜索的参数的
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.nowTab = this.$route.params.type
        this.initPage()
        /**
         * 20-08-06 需求统一批量删除
         */
        if (route.name === 'kehuData') { // 客户主数据库
          if (this.pageTitle === '客户主数据') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '3', text: '新增审核', num: this.tabs[1] ? this.tabs[1].num : '0' },
              { linkName: '4', text: '纠错审核', num: this.tabs[2] ? this.tabs[2].num : '0' },
              { linkName: '5', text: '删除审核', num: this.tabs[3] ? this.tabs[3].num : '0' },
              { linkName: '2', text: '回收站', num: this.tabs[4] ? this.tabs[4].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '3', text: '新增审核', num: '0' },
              { linkName: '4', text: '纠错审核', num: '0' },
              { linkName: '5', text: '删除审核', num: '0' },
              { linkName: '2', text: '回收站', num: '0' }
            ]
          }
          this.pageTitle = '客户主数据'
          this.actions = [
            // [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }, { type: '2', name: '批量删除', icon: 'iconpiliangshanchu' }],
            // [{ type: '3', name: '批量还原', icon: 'iconpilianghuanyuan' }]
            [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }],
            [{ type: '3', name: '批量还原', icon: 'iconpilianghuanyuan' }]
          ]
          const cols = [
            [],
            [ // 数据库
              // { width: 36, noDataWidth: 36, type: 'selection' },
              { field: '', title: '操作', width: 108, noDataWidth: 64, componentName: 'delAndEdit' },
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'source', title: '来源', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'is_terminal', title: '是否关联', width: 100, noDataWidth: 80, overflowTitle: true,
                formatter(rowData) {
                  return Number(rowData.is_terminal) === 1 ? '目标' : '非目标'
                }
              },
              { field: 'name', title: '名称', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'history_name', title: '曾用名', noDataWidth: 76, width: 200, overflowTitle: true },
              // { field: 'alias_name', title: '别名', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'p_name', title: '省', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'city_name', title: '市', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 100, noDataWidth: 76, overflowTitle: true },
              { field: 'address', title: '地址', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'is_target', title: '是否被设为目标', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否设为目标
              { field: 'is_clean', title: '是否关联清洗', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否关联清洗
              { field: 'dj', title: '药聚汇-等级', width: 110, noDataWidth: '108', overflowTitle: true },
              { field: 'wjw_dj', title: '卫计委-等级', width: 110, noDataWidth: '108', overflowTitle: true },
              { field: 'weiyi_dj', title: '微医-等级', width: 110, noDataWidth: '96', overflowTitle: true },
              { field: 'chunyu_dj', title: '春雨医生-等级', width: 110, noDataWidth: '120', overflowTitle: true },
              { field: 'haodaifu_dj', title: '好大夫-等级', width: 110, noDataWidth: '108', overflowTitle: true },
              { field: 'tel', title: '电话', width: 120, noDataWidth: '64', overflowTitle: true },
              { field: 'location_jingdu', title: '经度', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'location_weidu', title: '纬度', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'org_type_2_text', title: '终端分类', width: 140, noDataWidth: '88', overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型', width: 140, noDataWidth: '88', overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别', width: 140, noDataWidth: '88', overflowTitle: true },
              { field: 'reg_type_1_text', title: '经营性质', width: 100, noDataWidth: '88', overflowTitle: true },
              { field: 'reg_type_2_text', title: '所有制形式', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'le_type_2_text', title: '定级', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'le_type_3_text', title: '定等', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'is_junqu', title: '是否军区', width: 100, titleAlign: 'left', columnAlign: 'left' },
              { field: 'business_licence', title: '营业执照', width: 100, noDataWidth: '88', overflowTitle: true },
              { field: 'estab_date', title: '成立日期', width: 110, noDataWidth: '88', overflowTitle: true },
              { field: '', title: '营业期限', width: 220, noDataWidth: '88', overflowTitle: true,
                formatter(rowData) {
                  const str = rowData['business_start_date'] + ' — ' + rowData['business_end_date']
                  return str === ' — ' ? '' : str
                }
              },
              { field: 'operate_status', title: '经营状态', width: 180, noDataWidth: '88', overflowTitle: true },
              { field: 'website', title: '官网地址', width: 180, noDataWidth: '88', overflowTitle: true }
            ],
            [ // 回收站
              { width: 36, type: 'selection' },
              { field: '', title: '操作', width: 108, componentName: 'revent' },
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'source', title: '来源', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'is_terminal', title: '是否关联', width: 100, noDataWidth: 80, overflowTitle: true,
                formatter(rowData) {
                  return Number(rowData.is_terminal) === 1 ? '目标' : '非目标'
                }
              },
              { field: 'name', title: '名称', width: 200, noDataWidth: '64', overflowTitle: true },
              { field: 'history_name', title: '曾用名', noDataWidth: '76', width: 200, overflowTitle: true },
              // { field: 'alias_name', title: '别名', width: 200, noDataWidth: '64', overflowTitle: true },
              { field: 'p_name', title: '省', width: 100, noDataWidth: '52', overflowTitle: true },
              { field: 'city_name', title: '市', width: 100, noDataWidth: '52', overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 100, noDataWidth: '76', overflowTitle: true },
              { field: 'address', title: '地址', width: 200, noDataWidth: '64', overflowTitle: true },
              // { field: 'is_target', title: '是否被设为目标', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否设为目标
              // { field: 'is_clean', title: '是否关联清洗', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否关联清洗
              { field: 'dj', title: '药聚汇-等级', width: 110, noDataWidth: '108', overflowTitle: true },
              { field: 'wjw_dj', title: '卫计委-等级', width: 110, noDataWidth: '108', overflowTitle: true },
              { field: 'weiyi_dj', title: '微医-等级', width: 110, noDataWidth: '96', overflowTitle: true },
              { field: 'chunyu_dj', title: '春雨医生-等级', width: 110, noDataWidth: '120', overflowTitle: true },
              { field: 'haodaifu_dj', title: '好大夫-等级', width: 110, noDataWidth: '108', overflowTitle: true },
              { field: 'tel', title: '电话', width: 120, noDataWidth: '64', overflowTitle: true },
              { field: 'location_jingdu', title: '经度', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'location_weidu', title: '纬度', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'org_type_2_text', title: '终端分类', width: 140, noDataWidth: '88', overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型', width: 140, noDataWidth: '88', overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别', width: 140, noDataWidth: '88', overflowTitle: true },
              { field: 'reg_type_1_text', title: '经营性质', width: 100, noDataWidth: '88', overflowTitle: true },
              { field: 'reg_type_2_text', title: '所有制形式', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'le_type_2_text', title: '定级', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'le_type_3_text', title: '定等', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'is_junqu', title: '是否军区', width: 100, titleAlign: 'left', columnAlign: 'left' },
              { field: 'business_licence', title: '营业执照', width: 100, noDataWidth: '88', overflowTitle: true },
              { field: 'estab_date', title: '成立日期', width: 110, noDataWidth: '88', overflowTitle: true },
              { field: '', title: '营业期限', width: 220, noDataWidth: '88', overflowTitle: true,
                formatter(rowData) {
                  const str = rowData['business_start_date'] + ' — ' + rowData['business_end_date']
                  return str === ' — ' ? '' : str
                }
              },
              { field: 'operate_status', title: '经营状态', width: 180, noDataWidth: '88', overflowTitle: true },
              { field: 'website', title: '官网地址', width: 180, noDataWidth: '88', overflowTitle: true }
            ],
            [ // 新增申请 -2020-11-09表头更改
              { field: 'newapply', title: '操作', width: 108, componentName: 'revent' },
              // { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'backend_check_status', title: '审核状态', width: 100, noDataWidth: 80,
                formatter(rowData) {
                  if (rowData['backend_check_status'] * 1 === 30) {
                    return '通过'
                  } else if (rowData['backend_check_status'] * 1 === 20) {
                    return '驳回'
                  } else if (rowData['backend_check_status'] * 1 === 10 || rowData['backend_check_status'] * 1 === 100) {
                    return '待审核'
                  }
                }
              },
              { field: 'shenqing_leixing', title: '申请类型', width: 140, noDataWidth: '80', overflowTitle: true },
              { field: 'company_name', title: '申请公司', width: 140, noDataWidth: '80', overflowTitle: true },
              { field: 'member_truename', title: '申请人', width: 140, noDataWidth: '64', overflowTitle: true },
              { field: 'name', title: '客户名称-标准化', width: 200, noDataWidth: '140', overflowTitle: true },
              { field: 'history_name', title: '曾用名-标准化', noDataWidth: '140', width: 200, overflowTitle: true },
              { field: 'p_name', title: '省-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'city_name', title: '市-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'ad_name', title: '区/县-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'address', title: '地址-标准化', width: 200, noDataWidth: '100', overflowTitle: true },
              { field: 'dj', title: '药聚汇_等级-标准化', width: 140, noDataWidth: '140', overflowTitle: true },
              { field: 'org_type_2_text', title: '分类-标准化', width: 140, noDataWidth: '100', overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'reg_type_1_text', title: '经营性质-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'le_type_2_text', title: '定级-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'le_type_3_text', title: '定等-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'reg_type_2_text', title: '所有制形式-标准化', width: 140, noDataWidth: '140', overflowTitle: true },
              { field: 'is_junqu', title: '是否军区-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'frontend_original_url', title: '网站链接-标准化', width: 140, noDataWidth: '240', overflowTitle: true }
            ],
            [ // 纠错申请 2020-11-09表头字段更新
              { field: 'cus_jiu_apply', title: '操作', width: 108, componentName: 'revent' },
              // { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'backend_check_status', title: '审核状态', width: 100, noDataWidth: 100,
                formatter(rowData) {
                  if (rowData['backend_check_status'] * 1 === 60) {
                    return '通过'
                  } else if (rowData['backend_check_status'] * 1 === 50) {
                    return '驳回'
                  } else if (rowData['backend_check_status'] * 1 === 40) {
                    return '待审核'
                  }
                }
              },
              { field: 'company_name', title: '申请公司', width: 140, noDataWidth: '80', overflowTitle: true },
              { field: 'member_truename', title: '申请人', width: 140, noDataWidth: '64', overflowTitle: true },
              { field: 'name', title: '客户名称-标准化', width: 200, noDataWidth: '140', overflowTitle: true },
              { field: 'history_name', title: '曾用名-标准化', noDataWidth: '140', width: 200, overflowTitle: true },
              { field: 'p_name', title: '省-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'city_name', title: '市-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'ad_name', title: '区/县-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'address', title: '地址-标准化', width: 200, noDataWidth: '100', overflowTitle: true },
              { field: 'dj', title: '药聚汇_等级-标准化', width: 140, noDataWidth: '140', overflowTitle: true },
              { field: 'org_type_2_text', title: '分类-标准化', width: 140, noDataWidth: '100', overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'reg_type_1_text', title: '经营性质-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'le_type_2_text', title: '定级-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'le_type_3_text', title: '定等-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'reg_type_2_text', title: '所有制形式-标准化', width: 140, noDataWidth: '140', overflowTitle: true },
              { field: 'is_junqu', title: '是否军区-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'frontend_original_url', title: '网站链接-标准化', width: 140, noDataWidth: '240', overflowTitle: true }
            ],
            [ // 删除申请 2020-11-09 变更表头
              { field: 'cus_del_apply', title: '操作', width: 108, componentName: 'revent' },
              // { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'backend_check_status', title: '审核状态', width: 100, noDataWidth: 100,
                formatter(rowData) {
                  if (rowData['backend_check_status'] * 1 === 90) {
                    return '通过'
                  } else if (rowData['backend_check_status'] * 1 === 80) {
                    return '驳回'
                  } else if (rowData['backend_check_status'] * 1 === 70) {
                    return '待审核'
                  }
                }
              },
              { field: 'company_name', title: '申请公司', width: 140, noDataWidth: '80', overflowTitle: true },
              { field: 'member_truename', title: '申请人', width: 140, noDataWidth: '64', overflowTitle: true },
              { field: 'name', title: '客户名称-标准化', width: 200, noDataWidth: '140', overflowTitle: true },
              { field: 'history_name', title: '曾用名-标准化', noDataWidth: '140', width: 200, overflowTitle: true },
              { field: 'p_name', title: '省-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'city_name', title: '市-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'ad_name', title: '区/县-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'address', title: '地址-标准化', width: 200, noDataWidth: '100', overflowTitle: true },
              { field: 'dj', title: '药聚汇_等级-标准化', width: 140, noDataWidth: '140', overflowTitle: true },
              { field: 'org_type_2_text', title: '分类-标准化', width: 140, noDataWidth: '100', overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'reg_type_1_text', title: '经营性质-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'le_type_2_text', title: '定级-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'le_type_3_text', title: '定等-标准化', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'reg_type_2_text', title: '所有制形式-标准化', width: 140, noDataWidth: '140', overflowTitle: true },
              { field: 'is_junqu', title: '是否军区-标准化', width: 140, noDataWidth: '110', overflowTitle: true },
              { field: 'frontend_original_url', title: '网站链接-标准化', width: 140, noDataWidth: '240', overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'companyData') { // 生产企业数据库
          if (this.pageTitle === '生产企业数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '生产企业数据库'
          this.actions = [
            // [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }, { type: '2', name: '批量删除', icon: 'iconpiliangshanchu' }]
            [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }]
          ]
          const cols = [
            [],
            [
              // { width: 36, noDataWidth: '36', type: 'selection' },
              { field: '', title: '操作', width: 108, noDataWidth: '64', componentName: 'delAndEdit' },
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'source', title: '来源', width: 100, noDataWidth: '64', overflowTitle: true },
              { field: 'name', title: '企业名称', width: 200, noDataWidth: '88', overflowTitle: true },
              { field: 'history_name', title: '曾用名', width: 200, noDataWidth: '76', overflowTitle: true },
              // { field: 'alias_name', title: '别名', width: 200, noDataWidth: '64', overflowTitle: true },
              { field: 'org_type_2_text', title: '终端分类', width: 140, noDataWidth: '100', overflowTitle: true },
              { field: 'p_name', title: '省', width: 100, noDataWidth: '52', overflowTitle: true },
              { field: 'city_name', title: '市', width: 100, noDataWidth: '52', overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 100, noDataWidth: '76', overflowTitle: true },
              { field: 'address', title: '地址', width: 200, noDataWidth: '64', overflowTitle: true },
              { field: 'location_jingdu', title: '地理位置-经度', width: 100, noDataWidth: '120', overflowTitle: true },
              { field: 'location_weidu', title: '地理位置-纬度', width: 100, noDataWidth: '120', overflowTitle: true },
              { field: 'business_licence', title: '营业执照', width: 100, noDataWidth: '88', overflowTitle: true },
              { field: 'estab_date', title: '成立日期', width: 100, noDataWidth: '88', overflowTitle: true },
              { field: '', title: '营业期限', width: 220, noDataWidth: '88', overflowTitle: true,
                formatter(rowData) {
                  const str = rowData['business_start_date'] + ' — ' + rowData['business_end_date']
                  return str === ' — ' ? '' : str
                }
              },
              { field: 'operate_status', title: '经营状态', width: 180, noDataWidth: '88', overflowTitle: true },
              { field: 'tel', title: '联系电话', width: 120, noDataWidth: '88', overflowTitle: true },
              { field: 'website', title: '官网地址', width: 180, noDataWidth: '88', overflowTitle: true },
              { field: 'license_num', title: '药品生产许可证编号', width: 130, noDataWidth: '148', overflowTitle: true },
              { field: 'cat_code', title: '分类码', width: 60, noDataWidth: '76', overflowTitle: true },
              { field: 'busi_legal', title: '法定代表人', width: 90, noDataWidth: '100', overflowTitle: true },
              { field: 'busi_man', title: '企业负责人', width: 90, noDataWidth: '100', overflowTitle: true },
              { field: 'busi_range', title: '生产范围', width: 200, noDataWidth: '88', overflowTitle: true },
              { field: 'reg_addr', title: '注册地址', width: 200, noDataWidth: '88', overflowTitle: true },
              { field: 'prod_addr', title: '生产地址', width: 200, noDataWidth: '88', overflowTitle: true }, // 后台无返回字段
              { field: 'qa_person', title: '质量负责人', width: 100, noDataWidth: '100', overflowTitle: true },
              { field: 'fax', title: '公司传真', width: 120, noDataWidth: '88', overflowTitle: true },
              { field: 'issued', title: '发证机关', width: 200, noDataWidth: '88', overflowTitle: true },
              { field: 'sign_person', title: '签发人', width: 100, noDataWidth: '76', overflowTitle: true },
              { field: 'regulator', title: '日常监督机构', width: 200, noDataWidth: '112', overflowTitle: true },
              { field: 'supervisors', title: '日常监督人员', width: 100, noDataWidth: '112', overflowTitle: true },
              { field: 'supervisor_tel', title: '监督举报电话', width: 120, noDataWidth: '112', overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 100, noDataWidth: 114, componentName: 'jiucuo' },
              { field: 'count', title: '错误统计', width: 100, noDataWidth: 138 },
              { field: 'name', title: '企业名称', width: 200, noDataWidth: 138, overflowTitle: true },
              { field: 'business_licence', title: '营业执照', width: 100, noDataWidth: 138, overflowTitle: true },
              { field: 'license_num', title: '药品生产许可证编号', width: 140, noDataWidth: 198, overflowTitle: true },
              { field: 'busi_range', title: '生产范围', width: 170, noDataWidth: 138, overflowTitle: true },
              { field: 'cat_code', title: '分类码', width: 100, noDataWidth: 76 }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'shangyeData') { // 中国商业数据库
          if (this.pageTitle === '中国商业数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '中国商业数据库'
          this.actions = [
            // [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }, { type: '2', name: '批量删除', icon: 'iconpiliangshanchu' }]
            [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }]
          ]
          const cols = [
            [],
            [
              // { width: 36, noDataWidth: 36, type: 'selection' },
              { field: '', title: '操作', width: 108, noDataWidth: 64, componentName: 'delAndEdit' },
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'source', title: '来源', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'is_terminal', title: '是否关联', width: 100, noDataWidth: 80, overflowTitle: true,
                formatter(rowData) {
                  return Number(rowData.is_terminal) === 1 ? '目标' : '非目标'
                }
              },
              { field: 'name', title: '企业名称', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'history_name', title: '曾用名', width: 200, noDataWidth: 76, overflowTitle: true },
              // { field: 'alias_name', title: '别名', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'address', title: '地址', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'is_clean', title: '是否关联清洗', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否关联清洗
              { field: 'location_jingdu', title: '经度', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'location_weidu', title: '纬度', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'tel', title: '手机号', width: 120, noDataWidth: 76, overflowTitle: true },
              { field: 'p_name', title: '省', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'city_name', title: '市', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 100, noDataWidth: 76, overflowTitle: true },
              { field: 'org_type_2_text', title: '终端分类', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'license_num', title: '许可证编号', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'reg_addr', title: '注册地址', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'store_address', title: '仓库地址', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'busi_legal', title: '法人代表', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'busi_man', title: '企业负责人', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'qa_person', title: '质量负责人', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'busi_mode', title: '经营方式', width: 80, noDataWidth: 88, overflowTitle: true },
              { field: 'busi_range', title: '经营范围', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'issued', title: '发证机构', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'operate_status', title: '经营状态', width: 180, noDataWidth: 100, overflowTitle: true },
              { field: 'about_db', title: '相关数据查询', width: 100, noDataWidth: 112, overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 70, noDataWidth: 78, componentName: 'jiucuo' },
              { field: 'count', title: '错误统计', width: 70, noDataWidth: 102 },
              { field: 'name', title: '企业名称', width: 200, noDataWidth: 102, overflowTitle: true },
              { field: 'license_num', title: '许可证编号', width: 100, noDataWidth: 102, overflowTitle: true },
              { field: 'busi_mode', title: '经营方式', width: 100, noDataWidth: 102, overflowTitle: true },
              { field: 'busi_range', title: '经营范围', width: 200, noDataWidth: 102, overflowTitle: true },
              { field: 'reg_addr', title: '注册地址', width: 200, noDataWidth: 102, overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'yiliaoData') { // 中国医疗机构库
          if (this.pageTitle === '中国医疗机构库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '中国医疗机构库'
          this.actions = [
            // [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }, { type: '2', name: '批量删除', icon: 'iconpiliangshanchu' }]
            [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }]
          ]
          const cols = [
            [],
            [
              // { width: 36, noDataWidth: 36, type: 'selection' },
              { field: '', title: '操作', width: 108, noDataWidth: 64, componentName: 'delAndEdit' },
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'source', title: '来源', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'is_terminal', title: '是否关联', width: 100, noDataWidth: 80, overflowTitle: true,
                formatter(rowData) {
                  return Number(rowData.is_terminal) === 1 ? '目标' : '非目标'
                }
              },
              { field: 'name', title: '机构名称', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'history_name', title: '曾用名', width: 200, noDataWidth: 76, overflowTitle: true },
              // { field: 'alias_name', title: '别名', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'p_name', title: '省', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'city_name', title: '市', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 100, noDataWidth: 76, overflowTitle: true },
              { field: 'reg_type_1_text', title: '经营性质', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'reg_type_2_text', title: '所有制形式', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'dj', title: '药聚汇-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'wjw_dj', title: '卫计委-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'weiyi_dj', title: '微医-等级', width: 110, noDataWidth: 96, overflowTitle: true },
              { field: 'chunyu_dj', title: '春雨医生-等级', width: 110, noDataWidth: 120, overflowTitle: true },
              { field: 'haodaifu_dj', title: '好大夫-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'le_type_2_text', title: '定级', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'le_type_3_text', title: '定等', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'org_type_2_text', title: '终端分类', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'location_jingdu', title: '地理位置-经度', width: 100, noDataWidth: 120, overflowTitle: true },
              { field: 'location_weidu', title: '地理位置-纬度', width: 100, noDataWidth: 120, overflowTitle: true },
              { field: 'address', title: '地址', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'is_target', title: '是否被设为目标', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否设为目标
              { field: 'is_clean', title: '是否关联清洗', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否关联清洗
              { field: 'business_licence', title: '营业执照', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'estab_date', title: '成立日期', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: '', title: '营业期限', width: 220, noDataWidth: '88', overflowTitle: true,
                formatter(rowData) {
                  const str = rowData['business_start_date'] + ' — ' + rowData['business_end_date']
                  return str === ' — ' ? '' : str
                }
              },
              { field: 'operate_status', title: '经营状态', width: 180, noDataWidth: 88, overflowTitle: true },
              { field: 'tel', title: '联系电话', width: 120, noDataWidth: 88, overflowTitle: true },
              { field: 'website', title: '官网地址', width: 180, noDataWidth: 88, overflowTitle: true },
              { field: 'is_junqu', title: '是否军区', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'busi_man', title: '负责人', width: 100, noDataWidth: 76, overflowTitle: true },
              { field: 'bed_count', title: '床位数', width: 100, noDataWidth: 76, overflowTitle: true },
              { field: 'outpatient', title: '门诊量(日)', width: 100, noDataWidth: 112, overflowTitle: true },
              { field: 'diag_item', title: '诊疗项目', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'departments', title: '医院科室', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'doctors', title: '员工数', width: 100, noDataWidth: 76, overflowTitle: true },
              { field: 'hos_device', title: '医院设备', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'email', title: '邮箱', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'post', title: '邮编', width: 100, noDataWidth: 64, overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 80, noDataWidth: 114, componentName: 'jiucuo' },
              { field: 'count', title: '错误统计', width: 80, noDataWidth: 138 },
              { field: 'name', title: '机构名称', width: 170, noDataWidth: 138, overflowTitle: true },
              { field: 'org_type_4_text', title: '机构类型', width: 140, noDataWidth: 138, overflowTitle: true }, // ?
              { field: 'p_name', title: '省', width: 90, noDataWidth: 102, overflowTitle: true },
              { field: 'city_name', title: '市', width: 90, noDataWidth: 102, overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 90, noDataWidth: 102, overflowTitle: true },
              { field: 'address', title: '机构地址', width: 200, noDataWidth: 106, overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'yaodianData') { // 中国药店数据库
          if (this.pageTitle === '中国药店数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '中国药店数据库'
          this.actions = [
            // [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }, { type: '2', name: '批量删除', icon: 'iconpiliangshanchu' }]
            [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }]
          ]
          const cols = [
            [],
            [
              // { width: 36, noDataWidth: 36, type: 'selection' },
              { field: '', title: '操作', width: 108, noDataWidth: 64, componentName: 'delAndEdit' },
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'source', title: '来源', width: 100, noDataWidth: 64 },
              { field: 'is_terminal', title: '是否关联', width: 100, noDataWidth: 80, overflowTitle: true,
                formatter(rowData) {
                  return Number(rowData.is_terminal) === 1 ? '目标' : '非目标'
                }
              },
              { field: 'name', title: '名称', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'history_name', title: '曾用名', width: 200, noDataWidth: 88, overflowTitle: true },
              // { field: 'alias_name', title: '别名', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'address', title: '地址', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'is_target', title: '是否被设为目标', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否设为目标
              { field: 'is_clean', title: '是否关联清洗', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否关联清洗
              { field: 'dj', title: '药聚汇-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'wjw_dj', title: '卫计委-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'weiyi_dj', title: '微医-等级', width: 110, noDataWidth: 96, overflowTitle: true },
              { field: 'chunyu_dj', title: '春雨医生-等级', width: 110, noDataWidth: 120, overflowTitle: true },
              { field: 'haodaifu_dj', title: '好大夫-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'tel', title: '电话', width: 120, noDataWidth: 64, overflowTitle: true },
              { field: 'p_name', title: '省', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'city_name', title: '市', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'location_jingdu', title: '经度', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'location_weidu', title: '纬度', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'le_type_2', title: '定级', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'le_type_3', title: '定等', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'reg_type_1', title: '经营性质', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'reg_type_2', title: '所有制形式', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'license_num', title: '许可证号', width: 120, noDataWidth: 88, overflowTitle: true },
              { field: 'busi_legal', title: '企业法人', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'busi_man', title: '企业负责人', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'busi_mode', title: '经营方式', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'reg_addr', title: '注册地址', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'estab_date', title: '成立日期', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: '', title: '营业期限', width: 220, noDataWidth: '88', overflowTitle: true,
                formatter(rowData) {
                  const str = rowData['business_start_date'] + ' — ' + rowData['business_end_date']
                  return str === ' — ' ? '' : str
                }
              },
              { field: 'issued', title: '发证/审批机关', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'org_type_2_text', title: '终端分类', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'website', title: '官网地址', width: 180, noDataWidth: 88, overflowTitle: true },
              { field: 'store_address', title: '仓库地址', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'qa_person', title: '质量负责人', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'operate_status', title: '经营状态', width: 180, noDataWidth: 100, overflowTitle: true },
              { field: 'about_db', title: '相关数据查询', width: 100, noDataWidth: 112, overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 50, noDataWidth: 104, componentName: 'jiucuo' },
              { field: 'count', title: '错误统计', width: 80, noDataWidth: 128 },
              { field: 'name', title: '名称', width: 150, noDataWidth: 104, overflowTitle: true },
              { field: 'license_num', title: '许可证号', width: 100, noDataWidth: 128, overflowTitle: true },
              { field: 'busi_mode', title: '经营方式', width: 80, noDataWidth: 128, overflowTitle: true },
              { field: 'busi_range', title: '经营范围', width: 200, noDataWidth: 128, overflowTitle: true },
              { field: 'address', title: '地址', width: 180, noDataWidth: 104, overflowTitle: true },
              { field: 'estab_date', title: '成立日期', width: 100, noDataWidth: 116, overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'yiyuanData') { // 中国医院数据路
          if (this.pageTitle === '中国医院数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '中国医院数据库'
          this.actions = [
            // [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }, { type: '2', name: '批量删除', icon: 'iconpiliangshanchu' }]
            [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }]
          ]
          const cols = [
            [],
            [
              // { width: 36, noDataWidth: 36, type: 'selection' },
              { field: '', title: '操作', width: 108, noDataWidth: 64, componentName: 'delAndEdit' },
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'source', title: '来源', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'is_terminal', title: '是否关联', width: 100, noDataWidth: 80, overflowTitle: true,
                formatter(rowData) {
                  return Number(rowData.is_terminal) === 1 ? '目标' : '非目标'
                }
              },
              { field: 'name', title: '名称', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'history_name', title: '曾用名', width: 200, noDataWidth: 76, overflowTitle: true },
              // { field: 'alias_name', title: '别名', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'address', title: '地址', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'is_target', title: '是否被设为目标', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否设为目标
              { field: 'is_clean', title: '是否关联清洗', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否关联清洗
              { field: 'dj', title: '药聚汇-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'wjw_dj', title: '卫计委-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'weiyi_dj', title: '微医-等级', width: 110, noDataWidth: 96, overflowTitle: true },
              { field: 'chunyu_dj', title: '春雨医生-等级', width: 110, noDataWidth: 120, overflowTitle: true },
              { field: 'haodaifu_dj', title: '好大夫-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'tel', title: '电话', width: 120, noDataWidth: 64, overflowTitle: true },
              { field: 'p_name', title: '省', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'city_name', title: '市', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'location_jingdu', title: '经度', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'location_weidu', title: '纬度', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'org_type_2_text', title: '终端分类', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'le_type_2_text', title: '定级', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'le_type_3_text', title: '定等', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'reg_type_1_text', title: '经营性质', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'reg_type_2_text', title: '所有制形式', width: 100, noDataWidth: 112, overflowTitle: true },
              { field: 'bed_count', title: '床位数', width: 100, noDataWidth: 76, overflowTitle: true },
              { field: 'departments', title: '重点科室', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'business_licence', title: '营业执照', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: '', title: '营业期限', width: 220, noDataWidth: '88', overflowTitle: true,
                formatter(rowData) {
                  const str = rowData['business_start_date'] + ' — ' + rowData['business_end_date']
                  return str === ' — ' ? '' : str
                }
              },
              { field: 'operate_status', title: '经营状态', width: 180, noDataWidth: 88, overflowTitle: true },
              { field: 'is_junqu', title: '是否军区', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'outpatient', title: '门诊量(日)', width: 100, noDataWidth: 112, overflowTitle: true },
              { field: 'hos_device', title: '医院设备', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'ks_count', title: '科室数量', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'doctors', title: '医生数量', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'is_yibao', title: '是否医保', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'busi_man', title: '负责人', width: 100, noDataWidth: 76, overflowTitle: true },
              { field: 'diag_item', title: '诊疗项目', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'post', title: '邮编', width: 100, noDataWidth: 64, overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 60, noDataWidth: 84, componentName: 'jiucuo' },
              { field: 'count', title: '错误统计', width: 80, noDataWidth: 108 },
              { field: 'name', title: '名称', width: 150, noDataWidth: 84, overflowTitle: true },
              { field: 'dj', title: '药聚汇-等级', width: 90, noDataWidth: 128, overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别', width: 80, noDataWidth: 108, overflowTitle: true },
              { field: 'p_name', title: '省', width: 80, noDataWidth: 72, overflowTitle: true },
              { field: 'city_name', title: '市', width: 80, noDataWidth: 72, overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 80, noDataWidth: 72, overflowTitle: true },
              { field: 'bed_count', title: '床位数', width: 70, noDataWidth: 96, overflowTitle: true },
              { field: 'address', title: '地址', width: 170, noDataWidth: 116, overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'zhongduanData') { // 第三终端数据库
          if (this.pageTitle === '第三终端数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' }
            ]
          }
          this.pageTitle = '第三终端数据库'
          this.actions = [
            // [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }, { type: '2', name: '批量删除', icon: 'iconpiliangshanchu' }]
            [{ type: '1', name: '新增数据', icon: 'iconxinzengzhushuju' }]
          ]
          const cols = [
            [],
            [
              // { width: 36, noDataWidth: 36, type: 'selection' },
              { field: '', title: '操作', width: 108, noDataWidth: 64, componentName: 'delAndEdit' },
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'source', title: '来源', width: 100, noDataWidth: 64 },
              { field: 'is_terminal', title: '是否关联', width: 100, noDataWidth: 80, overflowTitle: true,
                formatter(rowData) {
                  return Number(rowData.is_terminal) === 1 ? '目标' : '非目标'
                }
              },
              { field: 'name', title: '名称', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'history_name', title: '曾用名', width: 200, noDataWidth: 76, overflowTitle: true },
              // { field: 'alias_name', title: '别名', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'address', title: '地址', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'is_target', title: '是否被设为目标', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否设为目标
              { field: 'is_clean', title: '是否关联清洗', width: 120, noDataWidth: 120, overflowTitle: true }, // 是否关联清洗
              { field: 'dj', title: '药聚汇-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'wjw_dj', title: '卫计委-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'weiyi_dj', title: '微医-等级', width: 110, noDataWidth: 96, overflowTitle: true },
              { field: 'chunyu_dj', title: '春雨医生-等级', width: 110, noDataWidth: 120, overflowTitle: true },
              { field: 'haodaifu_dj', title: '好大夫-等级', width: 110, noDataWidth: 108, overflowTitle: true },
              { field: 'tel', title: '电话', width: 120, noDataWidth: 64, overflowTitle: true },
              { field: 'fax', title: '传真号码', width: 120, noDataWidth: 88, overflowTitle: true },
              { field: 'post', title: '邮编', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'location_jingdu', title: '经度', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'location_weidu', title: '纬度', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'p_name', title: '省', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'city_name', title: '市', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'ad_name', title: '区、县', width: 100, noDataWidth: 52, overflowTitle: true },
              { field: 'le_type_2_text', title: '定级', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'le_type_3_text', title: '定等', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'org_type_2_text', title: '终端分类', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_3_text', title: '终端类型', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'org_type_4_text', title: '终端类别', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'reg_type_1_text', title: '经营性质', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'reg_type_2_text', title: '所有制形式', width: 100, noDataWidth: 112, overflowTitle: true },
              { field: 'business_licence', title: '营业执照', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: '', title: '营业期限', width: 220, noDataWidth: 88, overflowTitle: true,
                formatter(rowData) {
                  const str = rowData['business_start_date'] + ' — ' + rowData['business_end_date']
                  return str === ' — ' ? '' : str
                }
              },
              { field: 'operate_status', title: '经营状态', width: 180, noDataWidth: 88, overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'doctorData') { // 医药从业人员 - 医生数据库
          if (this.pageTitle === '医生数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '医生数据库'
          this.actions = [
            [],
            []
          ]
          const cols = [
            [],
            [
              { field: 'doctor_id', title: '编号', width: 108, noDataWidth: 120 },
              { field: 'doctor_name', title: '医生名称', width: 108, noDataWidth: 144, overflowTitle: true },
              { field: 'hos_name', title: '医院名称', width: 200, noDataWidth: 144, overflowTitle: true },
              { field: 'parent_name', title: '科室一级', width: 108, noDataWidth: 144, overflowTitle: true },
              { field: 'depart_name', title: '科室二级', width: 108, noDataWidth: 144, overflowTitle: true },
              { field: 'doctor_level', title: '医生等级', width: 108, noDataWidth: 144, overflowTitle: true },
              { field: 'doctor_good', title: '专长', width: 200, noDataWidth: 100, overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 80, noDataWidth: 102, componentName: 'jiucuo' },
              { field: 'count', title: '错误统计', width: 80, noDataWidth: 126 },
              { field: 'doctor_name', title: '医生名称', width: 90, noDataWidth: 126, overflowTitle: true },
              { field: 'hos_name', title: '医院名称', width: 200, noDataWidth: 126, overflowTitle: true },
              { field: 'parent_name', title: '科室一级', width: 100, noDataWidth: 126, overflowTitle: true },
              { field: 'depart_name', title: '科室二级', width: 100, noDataWidth: 126, overflowTitle: true },
              { field: 'doctor_level', title: '医生等级', width: 90, noDataWidth: 126, overflowTitle: true },
              { field: 'doctor_good', title: '专长', width: 200, noDataWidth: 82, overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'jiyaoData') { // 产品标准库 - 中国基药数据库
          if (this.pageTitle === '中国基药数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '中国基药数据库'
          this.actions = [[], []]
          const cols = [
            [],
            [
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'breed_name', title: '药品名称', width: 160, noDataWidth: 118, overflowTitle: true },
              { field: 'english_name', title: '药品名称英文', width: 160, noDataWidth: 142, overflowTitle: true },
              { field: 'drug_form', title: '剂型规格', width: 160, noDataWidth: 118, overflowTitle: true },
              { field: 'one_directory', title: '药品类别一', width: 140, noDataWidth: 124, overflowTitle: true },
              { field: 'two_directory', title: '药品类别二', width: 140, noDataWidth: 124, overflowTitle: true },
              { field: 'context', title: '备注', width: 160, noDataWidth: 94, overflowTitle: true },
              { field: 'wen_jian_chu_chu', title: '文件出处', width: 160, noDataWidth: 126, overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 100, noDataWidth: 100, componentName: 'jiucuo' }, // 有无内容都均分表格
              { field: 'count', title: '错误统计', width: 100, noDataWidth: 100 },
              { field: 'breed_name', title: '药品名称', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'drug_form', title: '剂型规格', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'one_directory', title: '药品类别一', width: 100, noDataWidth: 100, overflowTitle: true },
              { field: 'two_directory', title: '药品类别二', width: 100, noDataWidth: 100, overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'guochanData') { // 产品标准库 - 国产药品数据库
          if (this.pageTitle === '国产药品数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '国产药品数据库'
          this.actions = [[], []]
          const cols = [
            [],
            [
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'appr_num', title: '批准文号', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'prod_name', title: '药品名称', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'en_name', title: '英文名称', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'comm_name', title: '商品名', width: 200, noDataWidth: 72, overflowTitle: true },
              { field: 'dosage_form', title: '剂型', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'specification', title: '规格', width: 100, noDataWidth: 64, overflowTitle: true },
              { field: 'listed_holder', title: '上市许可持有人', width: 120, noDataWidth: 124, overflowTitle: true },
              { field: 'ent_name', title: '生产厂家', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'ent_addr', title: '生产地址', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'prod_class', title: '药品类别', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'appr_time', title: '批准日期', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'appr_num_o', title: '原批准文号', width: 140, noDataWidth: 100, overflowTitle: true },
              { field: 'std_code', title: '药品本位码', width: 140, noDataWidth: 100, overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 70, noDataWidth: 100, componentName: 'jiucuo' },
              { field: 'count', title: '错误统计', width: 70, noDataWidth: 124 },
              { field: 'prod_name', title: '药品名称', width: 150, noDataWidth: 124, overflowTitle: true },
              { field: 'comm_name', title: '商品名', width: 150, noDataWidth: 112, overflowTitle: true },
              { field: 'prod_class', title: '药品类别', width: 70, noDataWidth: 124, overflowTitle: true },
              { field: 'appr_num', title: '批准文号', width: 140, noDataWidth: 124, overflowTitle: true },
              { field: 'std_code', title: '药品本位码', width: 130, noDataWidth: 136, overflowTitle: true },
              { field: 'ent_name', title: '生产厂家', width: 160, noDataWidth: 96, overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'jinkouData') { // 产品标准库 - 进口药品数据库
          if (this.pageTitle === '进口药品数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '进口药品数据库'
          this.actions = [[], []]
          const cols = [
            [],
            [
              { field: 'id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'prd_name', title: '药品名称(中文)', width: 200, noDataWidth: 136, overflowTitle: true },
              { field: 'en_prd_name', title: '药品名称(英文)', width: 200, noDataWidth: 136, overflowTitle: true },
              { field: 'comm_name', title: '商品名(中文)', width: 200, noDataWidth: 124, overflowTitle: true },
              { field: 'en_comm_name', title: '商品名(英文)', width: 200, noDataWidth: 124, overflowTitle: true },
              { field: 'reg_num', title: '注册证号', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'old_reg_num', title: '原注册证号', width: 140, noDataWidth: 100, overflowTitle: true },
              { field: 'reg_mark', title: '注册证号备注', width: 140, noDataWidth: 112, overflowTitle: true },
              { field: 'appr_num', title: '分包装批准文号', width: 140, noDataWidth: 124, overflowTitle: true },
              { field: 'com_name', title: '公司名称(中文)', width: 200, noDataWidth: 136, overflowTitle: true },
              { field: 'en_com_name', title: '公司名称(英文)', width: 200, noDataWidth: 136, overflowTitle: true },
              { field: 'address', title: '地址(中文)', width: 200, noDataWidth: 112, overflowTitle: true },
              { field: 'en_address', title: '地址(英文)', width: 200, noDataWidth: 112, overflowTitle: true },
              { field: 'region', title: '国家/地区(中文)', width: 140, noDataWidth: 142, overflowTitle: true },
              { field: 'en_region', title: '国家/地区(英文)', width: 140, noDataWidth: 142, overflowTitle: true },
              { field: 'dosage_form', title: '剂型(中文)', width: 140, noDataWidth: 112, overflowTitle: true },
              { field: 'specification', title: '规格(中文)', width: 140, noDataWidth: 112, overflowTitle: true },
              { field: 'pac_specification', title: '包装规格(中文)', width: 140, noDataWidth: 136, overflowTitle: true },
              { field: 'ent_name', title: '生产厂家(中文)', width: 200, noDataWidth: 136, overflowTitle: true },
              { field: 'en_ent_name', title: '生产厂家(英文)', width: 200, noDataWidth: 136, overflowTitle: true },
              { field: 'ent_addr', title: '厂家地址(中文)', width: 200, noDataWidth: 136, overflowTitle: true },
              { field: 'en_ent_addr', title: '厂家地址(英文)', width: 200, noDataWidth: 136, overflowTitle: true },
              { field: 'ent_region', title: '厂家国家/地区(中文)', width: 160, noDataWidth: 142, overflowTitle: true },
              { field: 'en_ent_region', title: '厂家国家/地区(英文)', width: 160, noDataWidth: 142, overflowTitle: true },
              { field: 'lic_time', title: '发证日期', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'expire_time', title: '有效截止日期', width: 100, noDataWidth: 112, overflowTitle: true },
              { field: 'pac_ent_name', title: '分包装企业名称', width: 200, noDataWidth: 124, overflowTitle: true },
              { field: 'pac_ent_addr', title: '分包装企业地址', width: 200, noDataWidth: 124, overflowTitle: true },
              { field: 'pac_appr_time', title: '分包装文号批准日期', width: 140, noDataWidth: 148, overflowTitle: true },
              { field: 'pac_appr_expire', title: '分包装文号有效截止日期', width: 160, noDataWidth: 160, overflowTitle: true },
              { field: 'prd_type', title: '药品类别', width: 140, noDataWidth: 88, overflowTitle: true },
              { field: 'std_code', title: '药品本位码', width: 140, noDataWidth: 100, overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 70, noDataWidth: 78, componentName: 'jiucuo' },
              { field: 'count', title: '错误统计', width: 70, noDataWidth: 106 },
              { field: 'prd_name', title: '药品名称(中文)', width: 150, noDataWidth: 152 },
              { field: 'comm_name', title: '商品名(中文)', width: 150, noDataWidth: 140 },
              { field: 'prd_type', title: '药品类别', width: 70, noDataWidth: 104 },
              { field: 'reg_num', title: '注册证号', width: 130, noDataWidth: 104 },
              { field: 'std_code', title: '药品本位码', width: 130, noDataWidth: 116 },
              { field: 'en_ent_name', title: '生产厂家(英文)', width: 170, noDataWidth: 140 }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        } else if (route.name === 'yibaoData') { // 产品标准库 - 中国医保数据库
          if (this.pageTitle === '中国医保数据库') {
            this.tabs = [
              { linkName: '1', text: '数据库', num: this.tabs[0] ? this.tabs[0].num : '0' },
              { linkName: '2', text: '纠错信息', num: this.tabs[1] ? this.tabs[1].num : '0' }
            ]
          } else {
            this.tabs = [
              { linkName: '1', text: '数据库', num: '0' },
              { linkName: '2', text: '纠错信息', num: '0' }
            ]
          }
          this.pageTitle = '中国医保数据库'
          this.actions = [[], []]
          const cols = [
            [],
            [
              { field: 'yibao_id', title: '编号', width: 100, noDataWidth: 64 },
              { field: 'yibao_drug', title: '药品名称', width: 200, noDataWidth: 88, overflowTitle: true },
              { field: 'drug_form', title: '剂型', width: 100, noDataWidth: 64, overflowTitle: true },
              // { field: 'alias_name', title: '别名', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'yaopinjihe_mofang', title: '药品集合(魔方)', width: 100, noDataWidth: 136, overflowTitle: true },
              { field: 'area', title: '医保地区', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'type', title: '医保类型', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'shoulutujing', title: '收录途径', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'is_execute', title: '是否执行', width: 100, noDataWidth: 88, overflowTitle: true,
                formatter(rowData) {
                  if (rowData['is_execute'] === '是') {
                    return '执行中'
                  } else if (rowData['is_execute'] === '否') {
                    return '已废止'
                  } else {
                    return ''
                  }
                }
              },
              { field: 'drug_type', title: '药品分类', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'fenleihuizong', title: '药品分类汇总', width: 200, noDataWidth: 112, overflowTitle: true },
              { field: 'yaopinleibie', title: '药品类别(医保)', width: 100, noDataWidth: 136, overflowTitle: true },
              { field: 'genggaichuchu', title: '更改出处', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'time_execute', title: '发文时间', width: 100, noDataWidth: 88, overflowTitle: true },
              { field: 'link', title: '链接', width: 200, noDataWidth: 64, overflowTitle: true },
              { field: 'memo', title: '备注', width: 200, noDataWidth: 64, overflowTitle: true }
            ],
            [
              { field: '', title: '操作', width: 70, noDataWidth: 76, componentName: 'jiucuo' },
              { field: 'count', title: '错误统计', width: 70, noDataWidth: 100 },
              { field: 'yibao_drug', title: '药品名称', width: 160, noDataWidth: 100, overflowTitle: true },
              { field: 'is_execute', title: '是否执行', width: 70, noDataWidth: 100, overflowTitle: true,
                formatter(rowData) {
                  if (rowData['is_execute'] === '是') {
                    return '执行中'
                  } else if (rowData['is_execute'] === '否') {
                    return '已废止'
                  } else {
                    return ''
                  }
                }
              },
              { field: 'drug_form', title: '剂型', width: 110, noDataWidth: 76, overflowTitle: true },
              { field: 'drug_type', title: '药品分类', width: 110, noDataWidth: 100, overflowTitle: true },
              { field: 'area', title: '医保地区', width: 70, noDataWidth: 100, overflowTitle: true },
              { field: 'type', title: '医保类型', width: 70, noDataWidth: 100, overflowTitle: true },
              { field: 'shoulutujing', title: '收录途径', width: 110, noDataWidth: 100, overflowTitle: true },
              { field: 'time_execute', title: '发文日期', width: 100, noDataWidth: 88, overflowTitle: true }
            ]
          ]
          this.tableCol = this.formatterCol(cols[this.$route.params.type])
        }
        this.getData() // 没有搜索参数的查询方法
      },
      immediate: true
    }
  },
  methods: {
    initPage() {
      this.pageSize = 30
      this.pageIndex = 1
      // this.total = 0 页面切换total 先变0
      this.templateParams = ''
      this.selectRowData = [] // 多选的值
    },
    formatterCol(col) {
      return col.map(item => {
        if (item.field === 'alias_name') {
          item.formatter = function(rowData) {
            if (rowData['alias_name']) {
              return rowData['alias_name'].split(',/,').join(',')
            } else {
              return ''
            }
          }
        }
        item.titleAlign = 'left'
        item.columnAlign = 'left'
        // 保存一份原始宽度 其实一开始就该写死
        item.originWidth = item.width
        item.isResize = true
        return item
      })
    },
    getData(params) {
      if (!params) {
        this.getRealData({})
      } else {
        this.getRealData(params)
      }
    },
    getRealData(params) {
      const realParams = Object.assign({}, params, {
        cp: this.pageIndex,
        rp: this.pageSize
      })
      this.loading = true
      this.templateParams = params // 暂存搜索参数点击查询就保留暂存参数
      if (this.$route.name === 'kehuData' || this.$route.params.type === '1') {
        this.btnDisabled = true
        // 数据库的都是用自己的route.name 回收站的单独用 huishouData
        // const name = this.$route.params.type === '1' ? this.$route.name : 'huishouData'
        let name = null
        if (this.$route.params.type === '1') {
          name = this.$route.name
        } else if (this.$route.params.type === '2') {
          name = 'huishouData'
        } else if (this.$route.params.type === '3') {
          name = 'newapply'
        } else if (this.$route.params.type === '4') {
          name = 'jiucuo'
        } else if (this.$route.params.type === '5') {
          name = 'shanchu'
        }
        publicDataList(realParams, name).then(res => {
          this.loading = false
          this.btnDisabled = false
          if (res.code === 0) {
            this.esName = res.result.es_name || ''
            this.selectRowData = [] // 每次获取获取都将当前选择值清空
            this.total = res.result.count
            this.tableData = res.result.list
            this.fields = res.result.search_fields.map(obj => { // 条件帅选的options集合
              return {
                label: obj.custom_name,
                value: obj.field_name,
                type: obj.type
              }
            })
            /**
             * 从返回之中拿到帅选项的下拉信息
             * 别名需求删除别名
             * 新增数据 商业数据删除'是否被设为目标'列
             */
            this.fields = this.fields.filter(item => {
              if (this.$route.name === 'shangyeData') {
                return !['别名', '是否被设为目标'].includes(item.label)
              } else {
                return item.label !== '别名'
              }
            })
            if (this.$route.name === 'kehuData') {
              // if (this.$route.params.type === '1') {
              //   this.tabs[0].num = res.result.count
              //   this.tabs[1].num = res.result.std_self_count
              //   this.tabs[2].num = res.result.recycle_count
              // } else if (this.$route.params.type === '2') { // 回收站
              //   this.tabs[0].num = res.result.standard_count
              //   this.tabs[1].num = res.result.std_self_count
              //   this.tabs[2].num = res.result.count
              // } else if (this.$route.params.type === '3') { // 新增申请
              //   this.tabs[0].num = res.result.standard_count
              //   this.tabs[1].num = res.result.count
              //   this.tabs[2].num = res.result.recycle_count
              // }
              this.tabs[0].num = res.result.std_count.standard_count // 数据库
              this.tabs[1].num = res.result.std_count.new_apply_count // 新增
              this.tabs[2].num = res.result.std_count.jiucuo_count // 纠错
              this.tabs[3].num = res.result.std_count.del_count // 删除
              this.tabs[4].num = res.result.std_count.recycle_count // 回收站
            } else {
              this.tabs[0].num = res.result.count
              if (this.tabs[1]) {
                this.tabs[1].num = res.result.correction_count
              }
            }
          } else {
            msg.call(this, res.msg)
            this.total = 0
            this.tableData = []
            this.fields = []
          }
          this.resetTableWidth()
        })
      } else { // 执行纠错请求 没有搜索参数
        const correctList = {
          jiyaoData: 'JiYao', // 基药
          guochanData: 'GuoChanYaoPin', // 国产药品
          jinkouData: 'JinKouYaoPin', // 进口药品
          yibaoData: 'YiBao', // 医保
          companyData: 'ShengChanQiYe', // 生产企业
          shangyeData: 'ServiceInfoCorp', // 商业
          yiliaoData: 'YiLiaoJiGou', // 医疗机构
          yaodianData: 'ServiceInfoShop', // 药店
          yiyuanData: 'ServiceInfoHospital', // 医院
          doctorData: 'YiSheng' // 医生
        }
        correction({
          type: correctList[this.$route.name],
          cp: this.pageIndex,
          rp: this.pageSize
        }).then(res => {
          this.loading = false
          if (res.code === 0) {
            this.total = res.result.count
            this.tableData = res.result.list
            this.tabs[0].num = res.result.standard_count
            this.tabs[1].num = res.result.count
          } else {
            msg.call(this, res.msg)
            this.total = 0
            this.tableData = []
          }
          this.resetTableWidth()
        })
      }
    },
    pageChange(page) {
      this.pageIndex = page
      this.getRealData(this.templateParams)
    },
    pageSizeChange(size) {
      this.pageIndex = 1
      this.pageSize = size
      this.getRealData(this.templateParams)
    },
    resetTableWidth() { // 根据返回的tableData重新计算表格宽度
      // 每次获取数据都将已选数据置空
      this.selectRowData = []
      if (this.tableData.length) {
        this.tableCol.map(obj => {
          obj.width = Number(obj.originWidth)
          return obj
        })
      } else {
        this.tableCol.map(obj => {
          obj.width = Number(obj.noDataWidth)
          return obj
        })
      }
    }
  }
}
